import React from 'react';
import { Link } from 'wouter';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';

import type { MenuEntry } from '../types/general';
import { ColorBackgroundColor } from '../types/themeTypes';

type Props = {
  entry: MenuEntry;
  location: string;
  theme: ColorBackgroundColor;
};

function MenuItem({ entry, location, theme }: Props) {
  const isCurrentMenuItem = location.includes(entry.link);
  const firstRoutePart = entry.link.substring(0, entry.link.lastIndexOf('/') + 1);
  const isCurrentParentMenuItem =
    location.startsWith(firstRoutePart) && entry.subEntries !== undefined && entry.subEntries.length > 0;

  return (
    <ListItem
      key={entry.link}
      disablePadding
      sx={{
        width: 'auto',
      }}
    >
      <ListItemButton disableGutters sx={{ padding: '0' }}>
        <Link href={entry.link}>
          <Container
            maxWidth={false}
            disableGutters
            sx={{
              padding: '12px 24px',
              color: theme.color,
              lineHeight: 1.5,
              fontWeight: '500',
              textDecoration: 'none',
            }}
          >
            <Typography
              sx={{
                borderBottomWidth: '2px',
                borderBottomStyle: 'solid',
                ...(isCurrentMenuItem || isCurrentParentMenuItem
                  ? { borderBottomColor: theme.color }
                  : { borderBottomColor: 'transparent' }),
              }}
            >
              {entry.label}
            </Typography>
          </Container>
        </Link>
      </ListItemButton>
    </ListItem>
  );
}

export default MenuItem;
